import { useEffect, useState } from "react";
import { collection, getDocs } from "@firebase/firestore";
import { database } from "../../database/firebase";

const useRoomCollection = () => {
  const [roomsData, setRoomsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getRoomsDetails = async () => {
      try {
        setLoading(true);
        const rooms = await getDocs(collection(database, "userRooms"));
        setRoomsData(
          rooms.docs.map((doc) => ({
            id: doc.id,
            data: doc.data(),
          }))
        );
        setLoading(false);
      } catch (error) {
        setError(error.message);
      }
    };
    getRoomsDetails();
  }, []);

  return {
    roomsData,
    loading,
    error,
  };
};

export default useRoomCollection;
